<div class="mm-dialog" test-target="login-or-password-dialog">
  <div class="mm-dialog__header">
    <h2 [mmTestTarget]="'dialog-title'" class="mm-dialog__title">
      {{ 'TIER.ONE.DIALOG.LOGIN.OR.PASSWORD.TITLE' | translate }}
    </h2>

    <button [mmTestTarget]="'tier-one-dialog-close-button'"
            class="mm-dialog__close"
            (click)="dialogRef.close('cancel')">
      <mm-icon class="mm-dialog__close-icon" name="cross"></mm-icon>
    </button>
  </div>

  <div class="mm-dialog__content">
    <p class="mm-dialog__body" [mmTestTarget]="'dialog-body'">
      {{ 'TIER.ONE.DIALOG.LOGIN.OR.PASSWORD.BODY_1' | translate }}
      <b>{{data}}</b>
      {{ 'TIER.ONE.DIALOG.LOGIN.OR.PASSWORD.BODY_2' | translate }}
      <br><br>
    </p>
  </div>

  <div class="mm-dialog__footer" fxLayout="row" fxLayoutGap="30px">

    <div>
      <h4>{{ 'TIER.ONE.DIALOG.GO_TO_FORGOT_PASSWORD.TITLE' | translate }}</h4>
      <button mm-button color="primary" class="mm-dialog__forgot-password"
              [mmTestTarget]="'tier-one-go-to-forgot-password-button'"
              (click)="dialogRef.close('forgotPassword')">
        {{ 'TIER.ONE.DIALOG.GO_TO_FORGOT_PASSWORD' | translate }}
      </button>
    </div>

    <div class="mm-dialog__divider"></div>

    <div>
      <h4>{{ 'TIER.ONE.DIALOG.GO_TO_LOGIN.TITLE' | translate }}</h4>

      <button mm-button color="primary"
              [mmTestTarget]="'tier-one-go-to-login-button'"
              (click)="dialogRef.close('login')">
        {{ 'TIER.ONE.DIALOG.GO_TO_LOGIN' | translate }}
      </button>
    </div>

  </div>
</div>
